<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to previous page" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="finance" pageId="reimbursements-self-service" color="white"></help-link>
                    <v-btn fab dark small color="primary" title="Create Reimbursements" @click="showAdd">
                        <v-icon dark>add</v-icon>
                    </v-btn>
                </v-toolbar>
            </v-card>
            <v-card class="elavation-1" style="margin-top:5px;"> 
                <v-toolbar flat height="45px">
                    <span class="font-weight-bold ">List of My Reimbursements</span>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="reimbursements"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <tr style="cursor:pointer;" @click="viewDetails(props.item.reimbursementsId)" title="Click to view details">
                            <td>{{props.item.reimbursementType}}</td>
                            <td>PHP {{numFormat.formatNumber(props.item.amount)}}</td>
                            <td>{{props.item.createdOn | moment('MMM DD, YYYY')}}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
        </v-flex>

        <v-dialog v-model="dialogAddEdit" width="500" persistent :fullscreen="isMobile">   
            <add-edit ref="addEditRef" :dialogAddEdit.sync="dialogAddEdit" @send="viewDetails"></add-edit>
        </v-dialog>
    </v-layout> 
</template>

<script>

import reimbursementsApi from '@/api/reimbursements'
import commonfn from '@/common/functions'
import numFormat from '@/common/num_format'
import pageKeys from '@/common/pagekeys'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {     
    name: 'MyReimbursements',
    metaInfo: {
        title: 'My Reimbursements',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View, create My Reimbursements' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'add-edit': () => import('@/components/Reimbursements/AddEditReimbursements')
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            commonfn,
            numFormat,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            error: false,
            errorMessage: '',
            loading: false,
            dialogAddEdit: false,
            headers: [
                {text: 'Type',align: 'left',value: 'reimbursementType', width: '20%', sortable:true},
                {text: 'Amount',align: 'left',value: 'amount',  width: '15%', sortable:true},
                {text: 'Created On',align: 'left',value: 'createdOn',  width: '15%', sortable:true},
                {text: 'Status',align: 'left',value: 'status',  width: '15%', sortable:true},
            ],
            reimbursements: []
        }
    },
    methods: {
        viewDetails(reimbursementsId) {
            this.$router.push(`/finance/myreimbursements/${reimbursementsId}`)
        },
        showAdd() {
            const data = {
                isRequestForOtherUser: false,
                pageKey: pageKeys.myreimbursements
            }
            this.$refs.addEditRef.setAdd(data)
            this.dialogAddEdit = true
        },
        async getMyReimbursements(show_loading) {
            try {
                this.loading = show_loading
                const response = await reimbursementsApi.getMyReimbursements()
                if (response.status == 200) {
                    this.reimbursements = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'My Reimbursements'
        })

        this.getMyReimbursements(true)
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        isMobile() {
            return window.innerWidth < 600
        },
    }
}
</script>